/* eslint-disable global-require */
/**
 * Dependency resolver for @fishx/remote-component.
 * Maps each external package (as declared in promotionRemotePBh5/fishx.config.ts externals)
 * to its runtime module so remote components can share dependencies with the host app.
 */
module.exports = {
  resolve: {
    react: () => require('react'),
    'react-dom': () => require('react-dom'),
    moment: () => require('moment'),
    'react-color': () => require('react-color'),
    classnames: () => require('classnames'),
  },
};
